<template>
  <div>
    <b-form-datepicker
      id="date"
      placeholder="Nenhuma Data"
      calendar-width="200"
      label-no-date-selected=""
      label-next-month="Próximo Mês"
      label-next-year="Próximo Ano"
      label-prev-month="Mês Anterior"
      label-prev-year="Ano Anterior"
      label-current-month="Mês Atual"
      label-help
      hide-header
      reset-button
      reset-button-variant="danger"
      label-reset-button="Limpar"
      v-model="date"
      @input="onInput(date)"
      :size="size"
      :date-format-options="{
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      }"
      locale="pt-BR"
    >
    </b-form-datepicker>
  </div>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: "md",
    },
  },
  name: "Calendario",
  data: function () {
    return {
      date: "",
    };
  },

  watch: {
    date(value) {
      this.date = value;
    },
  },

  methods: {
   onInput(vl) {
    this.date = vl;
   }
  },
  mounted() {
    //this.date = ''
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/util/Calendario.vue